import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { automatableValueTypes } from "../../primitives";
import { idValidator } from "../misc/id-validator";
export const nodePropertyValidator = T.model("node_property", T.object({
    typeName: T.literal("node_property"),
    id: idValidator("node_property"),
    value: automatableValueTypes
}));
export const SWNodePropertyRecordType = createRecordType("node_property", {
    migrations: defineMigrations({}),
    validator: nodePropertyValidator,
    scope: "document"
}).withDefaultProperties(()=>({}));
/** @public */ export function createNodePropertyId(id) {
    return `node_property:${id !== null && id !== void 0 ? id : nanoid()}`;
}
